import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive} from '@angular/core';

@Directive({
  selector: '[XLSValidator]',
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: XLSValidator, multi: true
    }
  ]
})

export class XLSValidator implements Validator {

  public static validate(formControl: UntypedFormControl ): any {
    
    if (formControl.value) {
        return XLSValidator.checkExtension(formControl);
    }
  }

  public static checkExtension(formControl: UntypedFormControl) {
    let valToLower = formControl.value.name.toLowerCase();
    let regex = new RegExp("(.*?)\.(xls|xlsx)$"); //add or remove required extensions here
    let regexTest = regex.test(valToLower);
    return !regexTest ? { "notSupportedxls": true } : null;
  }

  validate(formControl: UntypedFormControl): { [key: string]: any } {
    return XLSValidator.validate(formControl);
  }

}